import { Button } from '@/shared/ui/button.tsx';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/shared/ui/sheet.tsx"
import { BookCheck, Home, Menu, Rss, History, TvMinimalPlay, Images, ImagePlus, SquareTerminal, Inbox } from 'lucide-react'
import NavButton from './NavButton';
import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../context';
import { useAtomValue } from 'jotai';
import { themeAtom } from '../atoms/theme-atoms';

const MobileNavbar = () => {

  const { isPlayground, username } = useContext<AuthContextType>(AuthContext)

  const theme = useAtomValue(themeAtom)

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" className='block sm:hidden z-50' onClick={() => console.log("navbar opened")}><Menu /></Button>
      </SheetTrigger>
      <SheetContent side="left" className='w-[14vw] sm:w-[10vw] p-0 flex h-full items-start justify-center'>
        <div className='flex flex-col justify-between items-center h-full py-10'>
          <p></p>
          <div className="flex flex-col gap-6 text-gray-500 w-full">
            {!isPlayground && (
              <>
                <NavButton icon={<Home size={22} />} routeTo="/home" description="Home" name="Home" />
                <NavButton icon={<Images size={22} />} routeTo="/home/gallery" description="Image Gallery" name="Gallery" />
                {theme.showRecommend &&
                  <NavButton icon={<Rss size={22} />} routeTo="/home/recommend" description="Review" name="Review" />
                }
                {theme.isClient &&
                  <>
                    <NavButton icon={<BookCheck size={22} />} routeTo="/home/approve/2" description="Your workflow lineup" name="Scheduled" />
                    <NavButton icon={<History size={22} />} routeTo="/home/previous" description="Posted and Discarded Posts" name="Look Back" />
                  </>
                }
        {(username === "testuser") && (
          <>
            <NavButton icon={<ImagePlus size={22} />} routeTo="/home/admin/gallery-approve" description="Admin Gallery" name="Admin Gallery" />
            <NavButton icon={<SquareTerminal size={22} />} routeTo="/home/admin-conf" description="Admin Config" name="Admin Config" />
            <NavButton icon={<Inbox size={22} />} routeTo="/home/admin/feedback" description="Feedback" name="Feedback" />
          </>
        )}
              </>
            )}
            {isPlayground &&
              <NavButton icon={<TvMinimalPlay size={22} />} routeTo="/home/play" description="Playground" name="Playground" />
            }
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export default MobileNavbar;
